import { render, staticRenderFns } from "./FullScreenMain.vue?vue&type=template&id=226657a1&"
import script from "./FullScreenMain.vue?vue&type=script&lang=js&"
export * from "./FullScreenMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('226657a1')) {
      api.createRecord('226657a1', component.options)
    } else {
      api.reload('226657a1', component.options)
    }
    module.hot.accept("./FullScreenMain.vue?vue&type=template&id=226657a1&", function () {
      api.rerender('226657a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/FullScreenMain.vue"
export default component.exports